// src/utils/request.js
import axios from 'axios'
// export const API_BASE_URL = 'http://localhost:8088'
export const API_BASE_URL = '/api'

// 创建 axios 实例
const service = axios.create({
    baseURL: API_BASE_URL,
    timeout: 15000,
    headers: {
        'Content-Type': 'application/json'
    }
})

// 请求拦截器（可选）
service.interceptors.request.use(
    config => {
        // 例如设置 token
        // config.headers.Authorization = 'Bearer ' + getToken()
        return config
    },
    error => Promise.reject(error)
)

// 响应拦截器（可选）
service.interceptors.response.use(
    response => response.data,
    error => {
        console.error('请求失败：', error)
        return Promise.reject(error)
    }
)

// 封装通用请求方法
export function apiRequest({ url, method = 'GET', data = {}, params = {} }) {
    return service({
        url,
        method,
        data,
        params
    })
}
